import React, { useCallback } from "react";
import { Col, Row, Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { TABLE_SETTINGS } from "../../constants/translates";
import eventEmitter from "../../services/EventEmitter";

interface Props {
  onChangeScrollbarVisibility: (value: boolean) => void;
  onReorderChangeVisibility: (value: boolean) => void;
  isScrollbarVisible: boolean;
  isReorderEnabled: boolean;
  reorderable?: boolean;
}

const TableSettings: React.FC<Props> = ({
  onChangeScrollbarVisibility,
  isScrollbarVisible,
  isReorderEnabled,
  onReorderChangeVisibility,
  reorderable,
}) => {
  const onChangeScrollbarHandler = useCallback(
    (event: CheckboxChangeEvent) => {
      const { checked } = event.target;

      onChangeScrollbarVisibility(checked);
      eventEmitter.emit("table:re-render", null);
    },
    [onChangeScrollbarVisibility]
  );

  const onChangeReorderHandler = useCallback(
    (event: CheckboxChangeEvent) => {
      const { checked } = event.target;

      onReorderChangeVisibility(checked);
    },
    [onReorderChangeVisibility]
  );

  return (
    <Row>
      {reorderable ? (
        <Col>
          <Checkbox
            onChange={onChangeReorderHandler}
            checked={isReorderEnabled}
          >
            {TABLE_SETTINGS.can_reorder_columns}
          </Checkbox>
        </Col>
      ) : null}
      <Col>
        <Checkbox
          onChange={onChangeScrollbarHandler}
          checked={isScrollbarVisible}
        >
          {TABLE_SETTINGS.can_visible_scrollbar}
        </Checkbox>
      </Col>
    </Row>
  );
};

export default TableSettings;
